import { Adapter as o, getAdapter as r } from "../../../../../adapter.js";
import { TierSettingsModel as n } from "./tierSettings.model.js";
import { TierCycleAdapter as t } from "./tierCycle/tierCycle.adapter.js";
import { TierConversionRuleAdapter as l } from "./tierConversionRule/tierConversionRule.adapter.js";
class d extends o {
  adapt(e) {
    const i = r(l);
    return new n({
      initialBalance: e.initial_balance,
      cycle: e.cycle ? r(t).adapt(e.cycle) : void 0,
      conversionRules: e.conversion_rule ? e.conversion_rule.map(i.adapt) : []
    });
  }
  serialize(e) {
  }
}
export {
  d as TierSettingsAdapter
};
//# sourceMappingURL=tierSettings.adapter.js.map
